// src/components/home/Inicio.jsx
import React, { useEffect } from 'react';
import {
  Alert,
  AppBar,
  Box,
  Button,
  ButtonBase,
  CardMedia,
  Container,
  Grid,
  Modal,
  Snackbar,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import CasinoIcon from '@mui/icons-material/Casino';
import { keyframes } from '@mui/system';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useFetch } from '../../hook/useFetch';
import { rutas } from '../../rutas/rutas';
import { setInformacion } from '../../storage/slices/usuarios';
import { getCookie } from '../../utils/getCookie';

import tierra1 from '../../Web Mundo/GIF-ISLA-1HS_yzyprs_1_pnzh53.gif';
import tierra2 from '../../Web Mundo/TIERRA-HUESO-GIF_vcj73t_ji8wkf.gif';
import tierra3 from '../../Web Mundo/ISLA-ENERGIA_x5cvlq_ojo9ia.gif';
import tierra4 from '../../Web Mundo/swap.gif';
import tierra5 from '../../Web Mundo/tierra5.gif';

import { Cronometro } from '../cronometro/Cronometro';
import { Hueso } from '../ecosistema/Hueso';
import EntryOverlay from '../overlay/EntryOverlay';
import PetOverlay from '../PetOverlay/PetOverlay';
import AirdropBubble from './airdrops/AirdropBubble';
import { ModalPool } from './ModalPool';

const BURN_PATH = '/game/album?page=6';
const ARENA_PATH = '/game/arena';
const RANKING_PATH = '/game/album?page=7';
const MINING_PATH = '/game/album?page=8';
const CASINO_PATH = '/game/casino';

const ARENA_ENERGY_COST = 5;
const ARENA_ENTRY_FEE = 250;
const API_BASE_METRICS = 'https://bigdogbonegame.com';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '92vw', sm: 500, md: 1000 },
  maxHeight: '82vh',
  overflow: 'auto',
  bgcolor: 'rgba(15, 15, 20, 0.98)',
  color: '#fff',
  border: '1px solid rgba(255,255,255,0.16)',
  borderRadius: 3,
  boxShadow: 24,
  p: 2,
};

const BLOCK_MIN_HEIGHT = { xs: 300, sm: 320, md: 360 };
const IMG_HEIGHT = { xs: 170, sm: 190, md: 210 };

const ISLAND_IMG_SX = {
  width: '100%',
  height: IMG_HEIGHT,
  objectFit: 'contain',
  objectPosition: 'center bottom',
  display: 'block',
  userSelect: 'none',
  pointerEvents: 'none',
};

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
`;

const casinoPulse = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow:
      0 0 14px rgba(255, 215, 0, 0.65),
      0 0 28px rgba(255, 0, 128, 0.32);
  }
  50% {
    transform: scale(1.018);
    box-shadow:
      0 0 28px rgba(255, 235, 59, 1),
      0 0 54px rgba(255, 0, 128, 0.7);
  }
`;

const casinoShine = keyframes`
  0% { transform: translateX(-160%) skewX(-22deg); }
  55%, 100% { transform: translateX(260%) skewX(-22deg); }
`;

const badgePulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.12); }
`;

const MetricsHuesoButton = ({ user = '' }) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [day, setDay] = React.useState(0);
  const [week, setWeek] = React.useState(0);
  const [month, setMonth] = React.useState(0);
  const [burned, setBurned] = React.useState(0);

  const fetchMetrics = React.useCallback(async () => {
    try {
      setLoading(true);
      const url = user
        ? `${API_BASE_METRICS}/metrics/hueso?user=${encodeURIComponent(user)}`
        : `${API_BASE_METRICS}/metrics/hueso`;

      const res = await fetch(url, { method: 'GET' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const last = (arr) =>
        arr?.length ? Number(arr[arr.length - 1]?.total || 0) : 0;

      setDay(last(data?.dia));
      setWeek(last(data?.semana));
      setMonth(last(data?.mes));
      setBurned(Number(data?.quemado || 0));
    } catch (error) {
      console.error('[metrics/hueso] fetch error:', error?.message);
      setDay(0);
      setWeek(0);
      setMonth(0);
      setBurned(0);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (open) fetchMetrics();
  }, [open, fetchMetrics]);

  const fmt = (value) =>
    Number(value || 0).toLocaleString(undefined, {
      maximumFractionDigits: 8,
    });

  return (
    <>
      <ButtonBase
        onClick={() => setOpen(true)}
        sx={{
          borderRadius: 2,
          bgcolor: 'rgba(0,0,0,0.6)',
          p: 0.5,
          mb: 1,
          display: 'flex',
          justifyContent: 'center',
          transition: 'transform 120ms ease, opacity 120ms ease',
          '&:hover': { transform: 'translateY(-1px)', opacity: 0.95 },
        }}
        aria-label="Open HUESO metrics"
        title="HUESO metrics"
      >
        <CardMedia
          component="img"
          image="https://www.bigdogbonegame.com/static/media/barril-animado.67bade929e092f18cf89.gif"
          alt="HUESO metrics"
          sx={{ width: 42, height: 42, display: 'block' }}
          loading="lazy"
        />
      </ButtonBase>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="hueso-metrics-title"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'rgba(20,20,20,0.98)',
            color: '#fff',
            borderRadius: 3,
            p: 3,
            width: { xs: '88vw', sm: 340 },
            maxWidth: 340,
            textAlign: 'center',
            boxShadow: 24,
            outline: 'none',
          }}
        >
          <Typography
            id="hueso-metrics-title"
            variant="h6"
            sx={{ mb: 1.5, fontWeight: 800 }}
          >
            🦴✨ Total HUESO Mined from the Lands
          </Typography>

          <Typography variant="body2" sx={{ mb: 0.5 }}>
            🌞 Day: <b>{loading ? '…' : fmt(day)}</b>
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            🗓️ Week: <b>{loading ? '…' : fmt(week)}</b>
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            🚀 Month: <b>{loading ? '…' : fmt(month)}</b>
          </Typography>

          <Box
            sx={{
              mt: 1.5,
              p: 1,
              borderRadius: 2,
              bgcolor: 'rgba(255,69,0,0.12)',
              border: '1px solid rgba(255,69,0,0.35)',
            }}
          >
            <Typography variant="body2">
              🔥 <b>Burned:</b> {loading ? '…' : fmt(burned)}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              Manual total from admin
            </Typography>
          </Box>

          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={fetchMetrics}
            disabled={loading}
          >
            🔄 Refresh
          </Button>
        </Box>
      </Modal>
    </>
  );
};

const CasinoHomeBanner = ({ onClick }) => (
  <ButtonBase
    onClick={onClick}
    aria-label="Open HUESO Casino"
    sx={{
      position: 'relative',
      width: '100%',
      minHeight: { xs: 94, sm: 110 },
      mb: { xs: 2.5, md: 3.5 },
      px: { xs: 1.5, sm: 3 },
      py: 1.4,
      overflow: 'hidden',
      borderRadius: 4,
      color: '#fff',
      border: '3px solid rgba(255, 230, 110, 0.92)',
      background:
        'linear-gradient(110deg, #170033 0%, #5d087c 24%, #d00072 52%, #ff7a00 77%, #ffd740 100%)',
      animation: `${casinoPulse} 1.4s ease-in-out infinite`,
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-45%',
        left: '-25%',
        width: '28%',
        height: '190%',
        bgcolor: 'rgba(255,255,255,0.34)',
        filter: 'blur(2px)',
        animation: `${casinoShine} 2.35s ease-in-out infinite`,
      },
      '&:hover': {
        filter: 'brightness(1.08)',
      },
      '&:focus-visible': {
        outline: '4px solid rgba(255,255,255,0.95)',
        outlineOffset: 3,
      },
      '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        '&::before': { animation: 'none' },
      },
    }}
  >
    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 1.2, sm: 2.2 },
      }}
    >
      <CasinoIcon sx={{ fontSize: { xs: 44, sm: 62 } }} />

      <Box sx={{ textAlign: 'left' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            sx={{
              fontWeight: 950,
              fontSize: { xs: '1.05rem', sm: '1.55rem' },
              lineHeight: 1.1,
              textShadow: '0 2px 8px rgba(0,0,0,0.8)',
            }}
          >
            🎰 HUESO CASINO
          </Typography>

          <Box
            component="span"
            sx={{
              px: 0.8,
              py: 0.25,
              borderRadius: 999,
              bgcolor: '#ff1744',
              fontSize: { xs: '0.58rem', sm: '0.7rem' },
              fontWeight: 950,
              animation: `${badgePulse} 0.85s ease-in-out infinite`,
              '@media (prefers-reduced-motion: reduce)': {
                animation: 'none',
              },
            }}
          >
            NEW
          </Box>
        </Box>

        <Typography
          sx={{
            mt: 0.45,
            fontWeight: 800,
            fontSize: { xs: '0.72rem', sm: '0.95rem' },
            opacity: 0.96,
            textShadow: '0 1px 5px rgba(0,0,0,0.85)',
          }}
        >
          Five animated mini-games · Bet and win with HUESO · Tap to enter
        </Typography>
      </Box>
    </Box>
  </ButtonBase>
);

export const Inicio = () => {
  const [peticion] = useFetch();
  const { informacion } = useSelector((state) => state.userSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [missionNoticeOpen, setMissionNoticeOpen] = React.useState(false);
  const [missionError, setMissionError] = React.useState(false);
  const [missionNoticeText, setMissionNoticeText] = React.useState('');
  const [poolOpen, setPoolOpen] = React.useState(false);
  const [ecosystemOpen, setEcosystemOpen] = React.useState(false);
  const [timeServer, setTimeServer] = React.useState('');
  const [messageVisible, setMessageVisible] = React.useState(false);
  const [mensaje, setMensaje] = React.useState({
    texto: '',
    linkUrl: '',
    linkLabel: '',
  });
  const [showEntryOverlay, setShowEntryOverlay] = React.useState(false);

  useEffect(() => {
    setShowEntryOverlay(true);
  }, []);

  useEffect(() => {
    let mounted = true;
    let messageTimer;
    const tokenJWT = getCookie('token');

    axios
      .get(rutas.getInformacion, {
        headers: { token: tokenJWT },
      })
      .then((res) => {
        if (!mounted) return;

        if (res.data?.resultado?.hora) {
          setTimeServer(res.data.resultado.hora);
        }

        const nextMessage = res.data?.mensajes || {
          texto: '',
          linkUrl: '',
          linkLabel: '',
        };

        setMensaje(nextMessage);

        if (nextMessage?.texto) {
          setMessageVisible(true);
          messageTimer = window.setTimeout(() => {
            if (mounted) setMessageVisible(false);
          }, 30000);
        }
      })
      .catch((error) => {
        console.error(
          '[Inicio] Error loading initial information:',
          error?.response?.data || error?.message
        );
      });

    return () => {
      mounted = false;
      if (messageTimer) window.clearTimeout(messageTimer);
    };
  }, []);

  const gameLogos = [
    {
      name: 'City Farm web game',
      logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755052377/logos/logo_xyjkop.png',
      type: 'external',
      href: 'https://cityfarmgame.com/',
    },
    {
      name: 'Bot Game Nova La exploradora',
      logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755052358/logos/logo_nova_hv5mrd.png',
      type: 'external',
      href: 'https://discord.gg/ShA6MKRHz9',
    },
    {
      name: 'Bot Mundo Airdrops',
      logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755052363/logos/mundoairdrops_s6mwyo.png',
      type: 'external',
      href: 'https://mundo-virtual.gitbook.io/mundo-bot-discord/',
    },
  ];

  const appsLogos = [
    {
      name: 'Market HiveNFTs',
      logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755319758/hivenfts-logo_sawbud.png',
      type: 'external',
      href: 'https://hivenfts.com/big-dog-bone/buy/',
    },
    {
      name: 'Buy or Sell HUESO',
      logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755113326/7._hueso_1_astveu.png',
      type: 'external',
      href: 'https://tribaldex.com/swap?from=SWAP.HIVE&to=HUESO',
    },
    {
      name: 'Buy or Sell VIPHUESO',
      logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755113343/8._viph_bn9r8g.webp',
      type: 'external',
      href: 'https://tribaldex.com/swap?from=SWAP.HIVE&to=VIPHUESO',
    },
  ];

  const goToLogo = (item) => {
    if (item.type === 'internal' && item.to) {
      navigate(item.to);
      return;
    }

    if (item.type === 'external' && item.href) {
      window.open(item.href, '_blank', 'noopener,noreferrer');
    }
  };

  const VerticalLogosRight = ({ items, sx: extraSx = {}, children }) => (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 96, sm: 120 },
        right: { xs: 8, sm: 16 },
        display: 'flex',
        flexDirection: 'column',
        gap: 1.2,
        zIndex: 1200,
        p: 1,
        borderRadius: 3,
        bgcolor: 'rgba(255,255,255,0.08)',
        backdropFilter: 'blur(4px)',
        boxShadow: 3,
        ...extraSx,
      }}
    >
      {children}

      {items.map((item, index) => (
        <Tooltip key={item.name} title={item.name} arrow placement="left">
          <ButtonBase
            onClick={() => goToLogo(item)}
            sx={{
              borderRadius: 2,
              p: 0.5,
              transition: 'transform 120ms ease, opacity 120ms ease',
              '&:hover': {
                transform: 'translateX(-2px)',
                opacity: 0.9,
              },
            }}
            aria-label={`Open ${item.name}`}
          >
            <CardMedia
              component="img"
              image={item.logo}
              alt={item.name}
              loading="lazy"
              sx={{
                width: { xs: 42, sm: 54 },
                height: 'auto',
                display: 'block',
                borderRadius: 1.5,
                willChange: 'transform',
                transformOrigin: 'center',
                animation: `${pulse} 1.6s ease-in-out infinite`,
                animationDelay: `${index * 0.12}s`,
                '@media (prefers-reduced-motion: reduce)': {
                  animation: 'none',
                },
              }}
            />
          </ButtonBase>
        </Tooltip>
      ))}
    </Box>
  );

  const buildPetMissionMessage = (tipo, resultado) => {
    const petBenefit = resultado?.petBenefit;
    const petApplied = resultado?.petApplied;

    let baseText = 'Mission started successfully';

    if (tipo === 4) baseText = '4-hour special mission started successfully';
    else if (tipo === 1) baseText = '1-hour mission started successfully';
    else if (tipo === 6) baseText = '6-hour mission started successfully';
    else if (tipo === 3) {
      baseText = 'Energy recharge mission started successfully';
    }

    if (!petBenefit) return baseText;

    if (!petBenefit.active) {
      return `${baseText}. Puppy bonus inactive. Keep your puppy healthy to activate bonuses.`;
    }

    const energy = petApplied?.energy;
    const time = petApplied?.time;
    const parts = [];

    if (
      Number(energy?.energyBonusPercent || 0) > 0 &&
      Number(energy?.savedEnergy || 0) > 0
    ) {
      parts.push(
        `Energy bonus: ${energy.energyBonusPercent}% saved ${energy.savedEnergy} energy`
      );
    }

    if (
      tipo === 6 &&
      Number(time?.walkTimeReductionPercent || 0) > 0 &&
      Number(time?.savedMinutes || 0) > 0
    ) {
      parts.push(
        `Walk reduction: ${time.walkTimeReductionPercent}% saved ${time.savedMinutes} minutes`
      );
    }

    if (!parts.length) return `${baseText}. Puppy bonus active.`;
    return `${baseText}. ${parts.join(' | ')}`;
  };

  const mision = async (tipo) => {
    try {
      if (
        tipo === 4 &&
        !['mv-deposito', 'lavino'].includes(informacion?.nombre)
      ) {
        setMissionNoticeText('It is not yet available. It will be soon.');
        setMissionError(true);
        setMissionNoticeOpen(true);
        return;
      }

      const resultado = await peticion(rutas.mision, 'post', {
        mision: tipo,
      });

      if (!resultado) return;

      if (resultado?.usuario) {
        dispatch(setInformacion(resultado.usuario));
      }

      setMissionError(false);
      setMissionNoticeText(buildPetMissionMessage(tipo, resultado));
      setMissionNoticeOpen(true);
    } catch (error) {
      setMissionNoticeText(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          'Mission error'
      );
      setMissionError(true);
      setMissionNoticeOpen(true);
    }
  };

  const energiaActual = Number(
    (informacion?.energia && typeof informacion.energia === 'object'
      ? informacion.energia.actual
      : informacion?.energia) ?? 0
  );

  const hasEnoughEnergyForArena = energiaActual >= ARENA_ENERGY_COST;

  const goArena = () => {
    if (!hasEnoughEnergyForArena) return;
    navigate(ARENA_PATH);
  };

  const islandBlocks = [
    {
      key: 'isla1h',
      img: tierra1,
      infoLeft: `${informacion?.costos?.primera ?? 0} - energy`,
      infoRight: `1 - ${Number(informacion?.poder ?? 0) + 80} HUESOS`,
      btn: {
        label: 'DIG 1 HOUR',
        onClick: () => mision(1),
        disabled: Boolean(informacion?.mision?.start),
      },
    },
    {
      key: 'recharge',
      img: tierra3,
      infoLeft: '',
      infoRight: `${Number(informacion?.poderEnergia ?? 0) + 2} energy`,
      btn: {
        label: 'RECHARGE',
        onClick: () => mision(3),
        disabled: Boolean(informacion?.mision?.start),
        color: 'warning',
      },
    },
    {
      key: 'isla6h',
      img: tierra2,
      infoLeft: `${informacion?.costos?.segunda ?? 0} - energy`,
      infoRight: `10 - ${Number(informacion?.poder ?? 0) * 5 + 400} HUESOS`,
      btn: {
        label: 'WALK 6 HOURS',
        onClick: () => mision(6),
        disabled: Boolean(informacion?.mision?.start),
      },
    },
    {
      key: 'pool',
      img: tierra4,
      infoLeft: '',
      infoRight: '',
      btn: {
        label: informacion?.packInicial ? 'POOL' : 'BUY ISLAND',
        onClick: () =>
          informacion?.packInicial
            ? setPoolOpen(true)
            : navigate('/game/market', { replace: true }),
      },
    },
    {
      key: 'arena',
      img: 'https://res.cloudinary.com/druu0mcam/image/upload/v1719339315/swap-_3_rrlyrk_i8zkan.gif',
      infoLeft: `${ARENA_ENERGY_COST} energy`,
      infoRight: `Entry fee: ${ARENA_ENTRY_FEE} HUESO`,
      btn: {
        label: 'ENTER ARENA',
        onClick: goArena,
        disabled: !hasEnoughEnergyForArena,
      },
      tooltip: !hasEnoughEnergyForArena
        ? `Not enough energy (${energiaActual}/${ARENA_ENERGY_COST})`
        : '',
    },
    {
      key: 'isla4h',
      img: tierra5,
      infoLeft: `${Number(informacion?.costos?.primera ?? 0) * 2 + 5} - energy`,
      infoRight: `1 - ${Number(informacion?.poder ?? 0) + 200} HUESOS`,
      btn: {
        label: 'DIG 4 HOURS',
        onClick: () => mision(4),
        disabled: Boolean(informacion?.misionEspecial?.start),
        color: 'warning',
      },
    },
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        backgroundImage:
          'url(https://res.cloudinary.com/dpwv380jp/image/upload/v1754942090/Blue_And_Black_Modern_YouTube_Shorts_Outro_Mobile_Video_1_rmzcny.gif)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundAttachment: { xs: 'scroll', md: 'fixed' },
        py: { xs: 2, md: 4 },
        pb: { xs: 10, md: 6 },
      }}
    >
      {timeServer !== '' && informacion?.mision?.start && (
        <AppBar sx={{ position: 'relative', mb: 1 }}>
          <Toolbar
            disableGutters
            variant="dense"
            sx={{
              bgcolor: 'rgba(255,255,255,0.1)',
              justifyContent: 'center',
            }}
          >
            <Cronometro
              tipo="normal"
              timeServer={timeServer}
              time={informacion?.mision?.Tiempo}
            />
          </Toolbar>
        </AppBar>
      )}

      {timeServer !== '' && informacion?.misionEspecial?.start && (
        <AppBar sx={{ position: 'relative', mb: 1 }}>
          <Toolbar
            disableGutters
            variant="dense"
            sx={{
              bgcolor: 'rgba(255,165,0,0.8)',
              justifyContent: 'center',
            }}
          >
            <Typography sx={{ color: '#fff', fontWeight: 'bold', mr: 1 }}>
              SPECIAL:
            </Typography>
            <Cronometro
              tipo="especial"
              timeServer={timeServer}
              time={informacion?.misionEspecial?.Tiempo}
            />
          </Toolbar>
        </AppBar>
      )}

      <Container maxWidth="lg">
        <CasinoHomeBanner onClick={() => navigate(CASINO_PATH)} />

        <Grid container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
          {islandBlocks.map((block) => (
            <Grid
              key={block.key}
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ display: 'flex' }}
            >
              <Box
                sx={{
                  width: '100%',
                  minHeight: BLOCK_MIN_HEIGHT,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  px: { xs: 1, md: 2 },
                  transition: 'transform 160ms ease',
                  '&:hover': { transform: 'translateY(-4px)' },
                }}
              >
                <CardMedia
                  component="img"
                  image={block.img}
                  alt={block.key}
                  sx={ISLAND_IMG_SX}
                />

                {(block.infoLeft || block.infoRight) && (
                  <Box
                    sx={{
                      mt: 1,
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#ff5252',
                        fontWeight: 700,
                        visibility: block.infoLeft ? 'visible' : 'hidden',
                      }}
                    >
                      {block.infoLeft || '—'}
                    </Typography>
                    <Typography
                      sx={{
                        color: '#ff5252',
                        fontWeight: 700,
                        textAlign: 'right',
                        flexShrink: 0,
                      }}
                    >
                      {block.infoRight}
                    </Typography>
                  </Box>
                )}

                <Box sx={{ flexGrow: 1 }} />

                {block.tooltip ? (
                  <Tooltip title={block.tooltip} arrow placement="top">
                    <span style={{ width: '100%' }}>
                      <Button
                        fullWidth
                        sx={{ mt: 1.5 }}
                        onClick={block.btn.onClick}
                        variant="contained"
                        disabled={block.btn.disabled}
                        color={block.btn.color || 'primary'}
                      >
                        {block.btn.label}
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  <Button
                    fullWidth
                    sx={{ mt: 1.5 }}
                    onClick={block.btn.onClick}
                    variant="contained"
                    disabled={block.btn.disabled}
                    color={block.btn.color || 'primary'}
                  >
                    {block.btn.label}
                  </Button>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {messageVisible && mensaje?.texto && (
        <AppBar
          position="fixed"
          sx={{
            top: 'auto',
            bottom: 0,
            minHeight: 72,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            overflow: 'hidden',
          }}
        >
          <Container maxWidth="xl">
            <Toolbar
              disableGutters
              sx={{
                minHeight: '72px !important',
                display: 'flex',
                color: '#111',
                justifyContent: 'center',
                bgcolor: 'orange',
                alignItems: 'center',
                textAlign: 'center',
                px: 2,
                py: 1,
                gap: 1,
                flexWrap: 'wrap',
              }}
            >
              <Typography sx={{ fontSize: { xs: '0.9rem', md: '1.1rem' } }}>
                {mensaje.texto}
              </Typography>

              {mensaje.linkUrl && (
                <Button
                  component="a"
                  href={mensaje.linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{ ml: { xs: 0, md: 2 }, fontWeight: 'bold' }}
                >
                  {mensaje.linkLabel || 'More info'}
                </Button>
              )}
            </Toolbar>
          </Container>
        </AppBar>
      )}

      <ModalPool handleClose={() => setPoolOpen(false)} open={poolOpen} />

      <Snackbar
        open={missionNoticeOpen}
        autoHideDuration={9000}
        onClose={() => setMissionNoticeOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={() => setMissionNoticeOpen(false)}
          severity={missionError ? 'error' : 'success'}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {missionNoticeText || (missionError ? 'Mission error' : 'Success')}
        </Alert>
      </Snackbar>

      <Modal
        open={ecosystemOpen}
        onClose={() => setEcosystemOpen(false)}
        aria-labelledby="ecosystem-modal-title"
        aria-describedby="ecosystem-modal-description"
      >
        <Box className="bordes scroll scroll-small" sx={modalStyle}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography id="ecosystem-modal-title" variant="h3">
              ECOSYSTEM
            </Typography>
            <Typography id="ecosystem-modal-description" variant="h6">
              Here you will find projects created by, or involving, the creator
              and owner of King of Duels, LAVINO.
            </Typography>
          </Box>
          <Hueso />
        </Box>
      </Modal>

      <VerticalLogosRight items={gameLogos}>
        <MetricsHuesoButton />
      </VerticalLogosRight>

      <VerticalLogosRight
        items={appsLogos}
        sx={{
          top: 'auto',
          bottom: { xs: 88, sm: 92 },
          right: { xs: 8, sm: 16 },
        }}
      />

      <EntryOverlay
        open={showEntryOverlay}
        onClose={() => setShowEntryOverlay(false)}
        mediaSrc="https://res.cloudinary.com/dekoxefky/video/upload/v1761188757/Mi_video_1_pyhe4b.mp4"
        casinoRoute={CASINO_PATH}
        burnRoute={BURN_PATH}
        arenaRoute={ARENA_PATH}
        rankingRoute={RANKING_PATH}
        miningRoute={MINING_PATH}
      />

      <AirdropBubble />

      <PetOverlay />
    </Box>
  );
};
